import { jsx as _jsx } from "react/jsx-runtime";
import MySettings from './about-me/MySettings';
import AboutMeProvider from './about-me-service/graphql/AboutMeProvider';
import PhraseProvider from './phrase/PhraseProvider';
function App({ aboutMeApiUri, labels }) {
    return (_jsx("div", Object.assign({ className: "App" }, { children: _jsx(PhraseProvider, Object.assign({ phrases: labels }, { children: _jsx(AboutMeProvider, Object.assign({ uri: aboutMeApiUri }, { children: _jsx(MySettings, {}) })) })) })));
}
export default App;
